<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-320.25 -434)">
			<path class="a" d="M0,0H45V45H0Z" transform="translate(320.25 434)" />
			<path
				d="M18.875,26.375h3.75v3.75h-3.75Zm0-15h3.75v11.25h-3.75ZM20.731,2A18.75,18.75,0,1,0,39.5,20.75,18.741,18.741,0,0,0,20.731,2Zm.019,33.75a15,15,0,1,1,15-15A15,15,0,0,1,20.75,35.75Z"
				transform="translate(322 435.75)"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-error-outline',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
.a {
	fill: none;
}
</style>

<docs>
    IconErrorOutline

    ```js
    <b-icon-error-outline />
    ```
</docs>
